import { render, staticRenderFns } from "./ag_test_suites.vue?vue&type=template&id=685a2ba8&scoped=true&"
import script from "./ag_test_suites.vue?vue&type=script&lang=ts&"
export * from "./ag_test_suites.vue?vue&type=script&lang=ts&"
import style0 from "./ag_test_suites.vue?vue&type=style&index=0&id=685a2ba8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685a2ba8",
  null
  
)

export default component.exports